module.exports = __webpack_public_path__ + "img/ep-arche.198c7d39.jpg";